import * as React from "react";
import {IconProps} from "../index";

export const LoadingSmall: React.FunctionComponent<IconProps> = ({color = 'white'}) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" role="img" xmlns="http://www.w3.org/2000/svg">
    <title>Loading</title>
    <path
      opacity="0.2"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 16.8254C13.3137 16.8254 16 14.1391 16 10.8254C16 7.51173 13.3137 4.82544 10 4.82544C6.68629 4.82544 4 7.51173 4 10.8254C4 14.1391 6.68629 16.8254 10 16.8254ZM10 18.8254C14.4183 18.8254 18 15.2437 18 10.8254C18 6.40716 14.4183 2.82544 10 2.82544C5.58172 2.82544 2 6.40716 2 10.8254C2 15.2437 5.58172 18.8254 10 18.8254Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4.82544C6.68629 4.82544 4 7.51173 4 10.8254C4 11.3777 3.55228 11.8254 3 11.8254C2.44772 11.8254 2 11.3777 2 10.8254C2 6.40716 5.58172 2.82544 10 2.82544C10.5523 2.82544 11 3.27315 11 3.82544C11 4.37772 10.5523 4.82544 10 4.82544Z"
      fill={color}
    />
  </svg>
);
